<template>
    <div>
        <section class="content">
            <div class="col-md-12" v-if="getMember.grades!=null">
                <div class="portlet light">
                  <div class="portlet-title" :style="{ 'min-height': hasPrevious2007(getGrades(true)) ? '48px':'32px' }">
                        <div class="caption pull-left">
                            <div class="subject">
                                <span class="caption-subject">Mes grades DAN/POOM/KEUP</span>
                                <span class="caption-helper"></span>
                            </div>
                            <div class="subsubject"  v-if="hasPrevious2007(getGrades(true))">
                                Pour des raisons techniques, les données antérieures à l'année 2007 ne peuvent être garanties.
                            </div>
                        </div>
                    </div>
                    <div class="portlet-body">
                        <table class="table table-responsive table-hover" v-if="getGrades(true).length>0">
                            <thead>
                            <tr>
                                <th>Date de formation</th>
                                <th>Formation</th>
                                <th>Diplôme</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="grade in getGrades(true)">
                                <td>{{grade.date}}</td>
                                <td>{{grade.formation}}</td>
                                <td>{{grade.diplome =="Aucun" ? '-' : grade.diplome}}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="getGrades(true).length==0">Aucun grade trouvé</div>
                    </div>
                </div>


            </div>

        </section>
    </div>
</template>

<script type="text/babel">
    import Auth from '@/auth'
    import moment from 'moment/moment'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data() {
            return {}
        },
        methods: {
            hasPrevious2007(table) {
                return _.find(table, function(item) {
                    return moment(item.dateSorted).isBefore("2007-01-01")
                })
            },
            currentYear: function () {
                return moment().year();
            },
            getGrades(withoutStageDPK = false, onlyStageDPK = false) {
                if (withoutStageDPK && !onlyStageDPK)
                    return _.filter(_.sortBy(this.getMember.grades, 'dateSorted').reverse(), (item) => {
                        return item.type != 'Stage Dan / Poom / Keup' && item.type != 'Séminaire ceinture noire'
                    })
                if (onlyStageDPK && !withoutStageDPK)
                    return _.filter(_.sortBy(this.getMember.grades, 'dateSorted').reverse(), (item) => {
                        return item.type == 'Stage Dan / Poom / Keup'
                    })

                return _.sortBy(this.getMember.grades, 'dateSorted',).reverse()
            }
        },
        components: {},
        computed: {
            ...mapGetters({
                getMember: 'getMember'
            })
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Member/Grades.vue